import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, This is Kritika Sharma`}</h1>
    <p>{`I'm currently pursuing BE in EEE from Sai Vidya Institute of Technology, Bangalore. I am currently a junior in my penultimate bachelors year.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      